import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionEngagementRoutingModule } from './session-engagement.routes';
import { SharedModule } from 'src/app/shared/shared.module';
import { ApiDataService } from "src/app/shared/services/api.service";
import { StudentsApiService } from "../../../app/feature-modules/student-list/services/students-api.service";
import { FormsModule } from "@angular/forms";
// import { AngularEditorModule } from '@kolkov/angular-editor';
import { StartPage } from './components/start-page/start-page.component';
import { PreEngagement } from './components/pre-engagement/pre-engagement.component';
import { Passage } from './components/passage/passage.component';
import { SessionManagement } from './components/session-management/session-management.component';
import { PostEngagement } from './components/post-engagement/post-engagement.component';
import { EngagementReview } from './components/review/engagement-review.component';
import { FinalReview } from './components/final-review/final-review.component';
import { LaserPointerComponent } from './components/laser-pointer/laser-pointer.component';
import { LessonTextComponent } from './components/passage-text/passage-text.component';
import { ButtonLoaderComponent } from 'src/app/shared/components/button-loader/button-loader.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';



@NgModule({
    declarations: [
        StartPage,
        PreEngagement,
        Passage,
        SessionManagement,
        LaserPointerComponent,
        LessonTextComponent,
        PostEngagement,
        EngagementReview,
        PostEngagement,
        EngagementReview,
        FinalReview,
        LaserPointerComponent,
        ButtonLoaderComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        SessionEngagementRoutingModule,
        FormsModule,
        SharedModule,
        MatProgressSpinnerModule,
    ],
    providers: [
        StudentsApiService,
        ApiDataService
    ],
    bootstrap: []
})
export class SessionEngagementModule { }
